import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { RichText } from '../RichText/RichText.js';
import { renderBenefitDescription } from './renderBenefitDescription.js';
import { renderBenefitLabel } from './renderBenefitLabel.js';
export const renderBenefitText = (_, i) => {
    return [
        'label' in _ ? renderBenefitLabel(_.label, i) : null,
        'description' in _ ? (_jsx("span", { className: _.descriptionClassName, children: renderBenefitDescription(_.description, i) }, String(i))) : null,
        '__html' in _ ? _jsx(RichText, { ..._ }, `rte-${i}`) : null,
    ];
};
//# sourceMappingURL=renderBenefitText.js.map